"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initializeSlickCarousel = () => {
    const slickSettings = {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px 20px',
                    edgeFriction: 1
                }
            }
        ]
    };
    $('.cards').slick(slickSettings);
};
const destroySlickCarousel = () => {
    if ($('.cards').hasClass('slick-initialized')) {
        $('.cards').slick('unslick');
    }
};
const handleResize = () => {
    const windowWidth = $(window).width();
    if (windowWidth && windowWidth < 992) {
        if (!$('.cards').hasClass('slick-initialized')) {
            initializeSlickCarousel();
        }
    }
    else {
        destroySlickCarousel();
    }
};
$(document).ready(() => {
    handleResize();
    $(window).on('resize', handleResize);
});
